import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
// import { Http } from '@angular/http';
import { SnotifyService } from 'ng-snotify';
import { Config } from '../../../config/config';
import { RestDataService } from '../../../service/rest-data.service';
import { SharedDataService } from '../../../service/shared-data.service';
import { StaticDataService } from '../../../service/static-data.service';
import { ElementModuleComponent } from '../../element-module/element-module.component';

@Component({
  selector: 'app-og-image',
  templateUrl: './og-image.component.html',
  styleUrls: ['./og-image.component.scss']
})
export class OgImageComponent implements OnInit {

  pickStoryImageLoad = false;
  imageUploadInProgress = false;
  focusOnOgMedia = false;
  leadMediaImageToggle = false;
  isLightbox = false;
  domainConfig = {};
  //storyEditMode = true;
  isPhotopopup = false;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  showCropper = false;
  tempLeadMedia = null;
  SingleselectedFileFlag = false;
  thumborCompressed: boolean;
  verticalImageFlag: boolean;
  SingleselectedFile: File = null;

  @Input()
  storyEditMode:any;

  @Input()
  changeFlag:any;

  @Input()
  storyType:any;

  @Input()
  storyData:any;

  @Input()
  Elements:any;

  @Input()
  elementChangeData:any;

  @Output() decrementCount = new EventEmitter<any>();
  @Output() incrementCount = new EventEmitter<any>();
  @Output() childKeyDownEventCatcherEmit = new EventEmitter<any>();
  @Output() failedImageUploadEmit = new EventEmitter<any>();
  @Output() getWordCountEmit = new EventEmitter<any>();
  @Output() currentCardIdEmit = new EventEmitter<any>();
  @Output() scrEmit = new EventEmitter<any>();
  @Output() autoSaveRequestEmit = new EventEmitter<any>();
  
  


  @ViewChildren('ogElement') ogRef: ElementModuleComponent;

  constructor(private sharedService: SharedDataService,
    private config: Config,
    private http: HttpClient,
    // private httpMethod: Http,
    private restService: RestDataService,
    private snotify: SnotifyService) { 
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
  }

  ngOnInit() {
  }

  getDomainConfig(currentDomainConfig) {
    this.domainConfig = currentDomainConfig;
  }

  setCheckForErrorIndication(index)
  {
    return false;
  }

  public listClick() {
      this.leadMediaImageToggle = !this.leadMediaImageToggle;
  }

  showGallery() {
    this.isLightbox = true;
    this.leadMediaImageToggle = true;
    this.isPhotopopup = true;
    this.sharedService.overflowhidden();
  }

  disableshowGallery() {
    this.isLightbox = false;
    this.leadMediaImageToggle = false;
    this.isPhotopopup = false;
    this.sharedService.overflowauto();
  }

  getLeadMediaId(obj) {

    if(obj && obj.data && obj.data.image && obj.data.image.verticalImage != null)
    {
      this.verticalImageFlag = obj.data.image.verticalImage;
    }
    this.SingleselectedFileFlag = true;
    if (!this.storyData.ogMedia
      || !this.storyData.ogMedia.elements
      || !this.storyData.ogMedia.id
      || !this.storyData.ogMedia.mediaType
    ) {
      this.storyData.ogMedia = {
        'elements': [],
        'id': null,
        'mediaType': null
      };
    }
    // debugger;
    // this.disableshowGallery();
    if (obj.type === 'wire') {
      this.saveCard(obj, 'leadMedia');
    } else {
      if (obj.id) {
        this.imageUploadInProgress = true;
        this.createDuplicateImageChild(obj.id, fn => {
          this.imageUploadInProgress = false;
          if (fn !== false) {
            const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
              this.sharedService.getImageOnPriority(fn.image.images, 'original');
              let link=this.sharedService.getImageOnPriority(fn.image.images, 'original');
              if(!link){
               this.showCropper = false;
               this.imageUploadInProgress = false;
               return this.snotify.error("Lead Media is not valid.",'',this.sharedService.getConfig(false))
              }
            this.showCropper = true;
            this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
              if (data !== false) {
                if (fn.hasOwnProperty('imageAmpValidated') && fn.imageAmpValidated) {
                  this.cropStartForImageFromInternalImages(fn, data);
                } else {
                  this.sharedService.checkImageForAMP(reader, flag => {
                    if (flag) {
                      this.cropStartForImageFromInternalImages(fn, data);
                    } else {
                      this.sharedService.showAMPConfirmPopup(() => { // yes
                        this.cropStartForImageFromInternalImages(fn, data);
                      },
                        () => { // no
                          this.cancelCropping();
                        }
                      );
                    }
                  });
                }
              } else {
                this.cancelCropping();
                this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
              }
            });
          } 
        });
        this.changeFlag = true;
      }
    }
  }


  cropStartForImageFromInternalImages(element, data) {
      this.setCroppingData(element, data);
  }

  setCroppingData(element, data) {
    this.tempLeadMedia = element.id;
    this.cropperImageUrl = data;
    this.thumborCompressed = element.image.thumborCompressed;
  }
  
  cancelCropping() {
    this.showCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null,
      blobData: null
    };
    this.imageUploadInProgress = false;
  }

  createDuplicateImageChild(id, callback, type?) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
      + '/' + id
    )
      .subscribe(result => {
        // let defaultImagecardData = $.extend(true, {}, result);
        // console.log(' result :: ');
        // console.log(result);
        let defaultImagecardData = Object.assign({}, result);
        defaultImagecardData['id'] = null;
        defaultImagecardData['parentElementId'] = id;
        defaultImagecardData['amazonAds'] = [
          {
            "key": "",
            "value": "",
            "isPresent": false
          }
        ];
        defaultImagecardData['amazonMeta'] = false;
        defaultImagecardData['amazonCheckedItem'] = false;
        defaultImagecardData['amazonTitle'] = '';
        defaultImagecardData['image']['images']['skipoptimize'] = "true";
        defaultImagecardData['relatedStories'] = null;
        defaultImagecardData['relatedVideoStories'] = null;
        if(defaultImagecardData['removeLowQualityRestriction']){
          delete defaultImagecardData['removeLowQualityRestriction']
        } 
        setTimeout(e => {
          this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result2 => {
              this.decreasePendingCount(null);
              if (!result2.hasOwnProperty('error')) {
                callback(result2);
                this.disableshowGallery();
              } else {
                this.snotify.error( result2.error.errorMessage ? result2.error.errorMessage : 'Error in Upload!',this.sharedService.getConfig(false))
                callback(false);
              }
            });
          this.restService.http_put(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'update_parent') + '/' + id,
            result, result2 => {
            });
        }, 50);
      },
        err => {
          callback(false);
        });
  }


  saveCard(imagePath, model) {
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd = new FormData();
    fd.set('file', imagePath.id);
    this.increasePendingCount();
    if (model === 'leadMedia') {
      this.showCropper = true;
      this.imageUploadInProgress = true;
    }
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        this.decreasePendingCount(null);
        if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.images['original'] = res['images']['original'];
          defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
          defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
          defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
          defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';
          defaultImagecardData.image.images['skipoptimize'] = "true";
          this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              console.log('result -- > ', result);
              this.decreasePendingCount(null);
              if (model === 'leadMedia') {
                this.imageUploadInProgress = false;
               
                if (result && !result.hasOwnProperty('error')) {
                  if (result.type && result.type === 'image') {
                    const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
                      this.sharedService.getImageOnPriority(result.image.images, 'original');
                     let link=this.sharedService.getImageOnPriority(result.image.images, 'original');
                     if(!link){
                      this.showCropper = false;
                      this.imageUploadInProgress = false;
                      return this.snotify.error("Lead Media is not valid.",'',this.sharedService.getConfig(false))
                     }
                    this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
                      if (data !== false) {
                        this.sharedService.checkImageForAMP(reader, flag => {
                          if (flag) {
                            this.cropStartForImageFromInternalImages(result, data);
                          } else {
                            this.sharedService.showAMPConfirmPopup(() => { // yes
                              this.cropStartForImageFromInternalImages(result, data);
                            },
                              () => { 
                                this.cancelCropping();
                              }
                            );
                          }
                        });
                      } else {
                        this.cancelCropping();
                        this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
                      }
                    });
                  } 
                } else {
                  this.cancelCropping();
                  this.snotify.error( result.error.errorMessage ? result.error.errorMessage : 'Error in Upload!',this.sharedService.getConfig(false))
                }
              } 
            });
        } else {
          if (model === 'leadMedia') {
            this.cancelCropping();
            this.snotify.error('Image creation failed.', '', this.sharedService.getConfig(false));
          }
        }
        return null;
      },
        err => {
          if(err.status==404){
           this.snotify.error( err.error.errorMessage,this.sharedService.getConfig(false))
          }
             this.showCropper = false;
            this.imageUploadInProgress = false;
             this.imageUploadInProgress = false;
        });
  }
  
  finishCropping(event) {
    console.log('finishCropping called');
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    if (this.SingleselectedFile) {
      this.increasePendingCount();
      this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          const { ampFlag, imagemap } = data;
          delete imagemap['ampImage'];
          console.log(data);
          if (this.SingleselectedFile) {
            const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
            ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            ImageCardData.id = null;
            ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
            ImageCardData.imageAmpValidated = ampFlag;
            ImageCardData.image.verticalImage = verticalFlag;
            ImageCardData.image.thumborCompressed = false;
            ImageCardData.image.images = imagemap;
            ImageCardData.image.images['skipoptimize'] = "true";
            this.SingleselectedFile = null;
            this.increasePendingCount();
            this.restService.http_post(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
              ImageCardData, image => {
                this.decreasePendingCount(null);
                if (!this.storyData.ogMedia
                  || !this.storyData.ogMedia.elements
                  || !this.storyData.ogMedia.id
                  || !this.storyData.ogMedia.mediaType
                ) {
                  this.storyData.ogMedia = {
                    'elements': [],
                    'id': null,
                    'mediaType': null
                  };
                }
                if (image.hasOwnProperty('error')) {
                  this.pickStoryImageLoad = false;
                  this.storyData.ogMedia.elements = [];
                  this.snotify.clear();
                  this.snotify.error('Try adding Lead Image again.', '', this.sharedService.getConfig(false));
                } else if (image) {
                    this.storyData.ogMedia.elements = [image.id];
                    this.storyData.ogMedia.mediaType = 'image';
                    this.pickStoryImageLoad = false;
                    setTimeout(e => {
                      this.ogRef['_results'][0].onelementFocus();
                    }, 500);
                    this.tempLeadMedia = null;
                    this.storyData.ogMedia.video = null;
                }
              });
          } 
        } else {
          // console.log(data);
        }
      });
    }
    else if(this.SingleselectedFileFlag){
      this.storyData.ogMedia.elements.push(this.tempLeadMedia);
      this.increasePendingCount();
      this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          const { ampFlag, imagemap } = data;
          this.pickStoryImageLoad = false;
          this.tempLeadMedia = null;
          delete imagemap['ampImage'];
          imagemap['skipoptimize'] = "true";
            this.ogRef['_results'][0].setImageUrl(
              ampFlag,
              verticalFlag,
              imagemap
            );
          }
      });
    }
    
  }

  increasePendingCount()
  {
    this.incrementCount.emit();
  }

  decreasePendingCount(count)
  {
    this.decrementCount.emit(count);
  }

  deleteImageCardEmit(ev) {
    if (this.storyData.ogMedia && this.storyData.ogMedia.elements.indexOf(ev) > -1) {
      this.storyData.ogMedia.elements.splice(this.storyData.ogMedia.elements.indexOf(ev), 1);
      this.storyData.ogMedia.defaultImage = false;
      // delete (this.Elements[ev]);
      this.changeFlag = true;
    } 
    this.isPhotopopup = false;
    this.sharedService.overflowauto();
  }

  getUpadtedElementContent(ev) {
    // if (ev && ev.id && ev.id !== null) {
    //   this.Elements[ev.id] = ev;
    // }
  }

  serveElementContent(id) {
    if (id && id !== null && this.elementChangeData.hasOwnProperty(id) && this.elementChangeData[id] !== null) {
      return this.elementChangeData[id];
    } else {
      return null;
    }
  }

  childKeyDownEventCatcher(event)
  {
    this.childKeyDownEventCatcherEmit.emit(event);
  }

  failedImageUploadCatcher()
  {
    this.failedImageUploadEmit.emit(true);
  }

  getWordCount(event)
  {
    this.getWordCountEmit.emit(event);
  }

  currentCardId(event)
  {
    this.currentCardIdEmit.emit(event);
  }

  scr(event)
  {
    this.scrEmit.emit(event);
  }

  autoSaveRequest(event)
  {
    this.autoSaveRequestEmit.emit(event);
  }

  onFileChangeSingle(event, model) {
    let file_name = <File>event.target.files[0].name;
    const reader = new FileReader();
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      this.SingleselectedFileFlag = false;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showCropper');
                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showCropper');
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      this.isLightbox = false;
      this.leadMediaImageToggle = false;
    } 

    uplaodImageAndOpenCropper(imageFile, base64, type) {
      this.imageUploadInProgress = true;
      this.snotify.info('Uploading', '', this.sharedService.getConfig(false));
      this.sharedService.uploadImage(imageFile).
        subscribe(res => {
          if(res['errorMessage']) {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.imageUploadInProgress = false;
            this.failedImageUploadCatcher();
            this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
          }
          this.cropperImageUrl.data = base64;
          this.cropperImageUrl.url = res['images']['original'];
          this.thumborCompressed = res['thumborCompressed'];
          if(type === 'showCropper') {
            this.showCropper = true;
          }
          this.imageUploadInProgress = false;
        },
          error => {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.imageUploadInProgress = false;
            if(error.error.errorMessage && error.error.errorMessage.indexOf('low')!=-1){
            this.failedImageUploadCatcher();
            this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
          }
          else
            this.snotify.error(error.error.errorMessage, '', this.sharedService.getConfig(false));
          });
    }
}
